import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  tinymce_text: string;
}

const propsSchema: PropsSchemaList = [
  {
    key: 'tinymce_text',
    label: 'TinyMCE Text Editor',
    type: types.TINYMCE,
  },
];

const defaultProps: Props = {
  tinymce_text: `
    <h1>TinyMCE Text Editor</h1>
    <p>
      Use this component to add custom text.
    </p>
  `,
};

export default {
  title: 'TinyMCE Text Editor',
  id: 'TinyMCE',
  propsSchema,
  defaultProps,
};
